module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Product Information")]), _vm._v(" "), _c('p', [_vm._v("Fill up all necessary information")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "proposeitem",
      "method": "POST",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "description",
      "id": "description"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "no_of_sockets"
    }
  }, [_vm._v("No. of Sockets")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "no_of_sockets",
      "id": "no_of_sockets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "package_dimensions"
    }
  }, [_vm._v("Package Dimension")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "package_dimensions",
      "id": "package_dimensions",
      "placeholder": "L x W x H"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "item_dimensions"
    }
  }, [_vm._v("Item Dimension")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "item_dimensions",
      "id": "item_dimensions",
      "placeholder": "L x W x H"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "min_order"
    }
  }, [_vm._v("Minimum order quantity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "min_order",
      "id": "min_order"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "price",
      "id": "price"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pricing"
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "pricing",
      "id": "pricing"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("FOB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("CIF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("CNF")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "currency"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "currency",
      "id": "currency"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Php")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Usd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("jpy")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Product Specifications")]), _vm._v(" "), _c('p', [_vm._v("Check all items that apply")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Design")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check1"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check1",
      "value": "val1"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Classic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check2"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check2",
      "value": "val2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Contemporary")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check3"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check3",
      "value": "val3"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Modern")]), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Materials")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check4"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check4",
      "value": "val4"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Acrylic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check5"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check5",
      "value": "val5"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Crystal")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check6"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check6",
      "value": "val6"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Plastic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check7"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check7",
      "value": "val7"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Aluminum")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check8"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check8",
      "value": "val8"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Glass")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check9"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check9",
      "value": "val9"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Wood")]), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Add other items here later")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e"
  }, [_vm._v("Propose Item")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-bottom": "40px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4029f855"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupplierProductProposal.vue
// module id = 149
// module chunks = 0